<!--
 * @Description: 
 -->
<template>
  <div style='width:100%;height:100%'>
    <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
     
    />
      <iframe src="https://www.baidu.com/" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>
<script>
 
export default {
  
  data() {
    return { }
  },
  
 
}
</script>
<style lang="scss" scoped>
/deep/ .van-nav-bar .van-icon {
  color: rgb(116, 180, 43);
}
/deep/ .van-nav-bar__text {
  color: rgb(116, 180, 43);
}
</style>
